import {createContext} from 'react';

type PruningPrefetchCacheContextType = AbortSignal | undefined;

export default createContext<PruningPrefetchCacheContextType>(undefined);
